import "./App.css";
import "./index.css";
import { React } from "react";
import { Routes, Route } from "react-router-dom";
import "bootstrap/dist/css/bootstrap.min.css";
import Header from "./components/superAdmin/dashboard/Header";
import Footer from "./components/superAdmin/footer/Footer";
import Default from "./routes/Default";
import { Suspense } from "react";
import { Spinner } from "react-bootstrap";
import ExhibitorDashboardNavbar from "./components/exhibitor/exhibitor_dashboard/ExhibitorDashboardNavbar";
import VisitorForm from "./components/HtmlMainPage/MainPage";
import InvitedVIPGuestList from "./components/exhibitor/SubAdminArea/InvitedVIPGuestList";
import AdminInvitedVIPGuestList from "./components/AdminVIP/AdminInvitedVIPGuestList";
import MainRoute from "./routes/MainRoute";
import SuperAdminAreaLogin from "./components/superAdmin/Settings/SuperAdminAreaLogin";
import AdminVIPLogin from "./components/AdminVIP/AdminVIPLogin";
import ExhibitorLogin from "./components/exhibitor/Form/ExhibitorLogin";
import ExhibitorStaff from "./components/visitorform/ExhibitorStaff";
import ExhibitorVip from "./components/visitorform/ExhibitorVip";
import ExhibitorOwner from "./components/visitorform/ExhibitorOwner";
import VendorOwner from "./components/visitorform/VendorOwner";
import VendorStaff from "./components/visitorform/VendorStaff";
import Wrong404 from "./404/Wrong404";
import FrontEndPage from "./components/HtmlMainPage/MainPage";
import HospitalityLogin from "./components/Hospitality/HospitalityLogin";
import CabServiceLogin from "./components/CabService/CarServiceLogin";
import FlightServicelogin from "./components/FlightService/FlightServiceLogin";
import BuyerRegistration from "./components/HtmlMainPage/BuyerRegistration";
import KceVisitorRegistration from "./components/HtmlMainPage/KceVisitorRegistration";
import NewVisitorForm from "./components/HtmlMainPage/NewVisitorForm";

import SuccessFullPage from "./components/HtmlMainPage/SuccessFullPage";
import FailPage from "./components/HtmlMainPage/FailPage";
import PaymentComponent from "./components/HtmlMainPage/PaymentComponent";
import BuyerAdminLogin from "./components/BuyerAdmin/BuyerAdminLogin";
import VisitorAdminLogin from "./components/visitorAdmin/VisitorAdminLogin";
import Privacy from "./components/HtmlMainPage/Privacy";
import Terms from "./components/HtmlMainPage/Terms";
import PaymentPage from './components/HtmlMainPage/PaymentComponent'
import ECard from './components/HtmlMainPage/ECard'
import EditBuyerForm from './components/superAdmin/exhibitor/EditBuyerForm'
import UploadPhoto from "./components/superAdmin/Settings/UploadPhoto";
import InvitationAccept from "./components/HtmlMainPage/InvitationAccept";

// Sub-Admin Module
import SubAdminRoute from "./modules/subadmin/components/SubAdminRoute";
import SubAdminDashboard from "./modules/subadmin/pages/Dashboard";
import SubAdminAreas from "./modules/subadmin/pages/Areas";
import SubAdminBuyers from "./modules/subadmin/pages/Buyers";
import SubAdminVisitors from "./modules/subadmin/pages/Visitors";
import SubAdminExhibitors from "./modules/subadmin/pages/Exhibitors";
import SubAdminLogin from "./modules/subadmin/pages/Login";
import SubAdminChangePassword from "./modules/subadmin/pages/ChangePassword";



function App() {
  return (
    <>
      {/* <MainPage/> */}
      {/* <Suspense fallback={<Spinner animation="border" size="lg" />}> */}
      <Suspense
        fallback={
          <div className="d-flex justify-content-center align-items-center content-height">
            Loading... &nbsp; &nbsp;
            <Spinner animation="border" size="lg" />
          </div>
        }
      >
        <Routes>
          <Route path="/coming-this-year/:barcode" element={<InvitationAccept />} />
          <Route path="/adminvip/login" element={<AdminVIPLogin />} />

          <Route path="/superadmin/login" element={<SuperAdminAreaLogin />} />
          <Route path="/subadmin/login" element={<SubAdminLogin />} />
          <Route path="/exhibitor/login" element={<ExhibitorLogin />} />
          <Route path="/hospitality/login" element={<HospitalityLogin />} />
          <Route path="/cab-service/login" element={<CabServiceLogin />} />
          <Route path="/buyer-admin/login" element={<BuyerAdminLogin />} />
          <Route path="/visitor-admin/login" element={<VisitorAdminLogin />} />
          <Route path="/agent/login" element={<ExhibitorLogin />} />
          <Route path="/associate/login" element={<ExhibitorLogin />} />
          <Route path="/sponser/login" element={<ExhibitorLogin />} />
          <Route path="/buyer/edit" element={<EditBuyerForm />} />


          <Route
            path="/flight-service/login"
            element={<FlightServicelogin />}
          />
          <Route path="/404" element={<Wrong404 />} />
          <Route path="/" element={<FrontEndPage />} />
          <Route path="/privacy-policy" element={<Privacy />} />

          <Route path="/terms-condition" element={<Terms />} />

          {/* <Route
            path="/exhibitor-staff-registration"
            element={<ExhibitorStaff />}
          /> */}
          <Route path="/registration" element={<VisitorForm />} />
          <Route path="/payment-successful" element={<SuccessFullPage />} />
          {/* <Route path="/payment" element={<PaymentComponent />} /> */}

          <Route path="/payment-failed" element={<FailPage />} />
          <Route path="/payment" element={<PaymentPage />} />
          {/*  */}
          <Route path="/e-pass" element={<ECard />} />


          <Route
            path="/visitor-registration"
            element={<NewVisitorForm />}
          />

          <Route
            path="/nri-registration"
            element={<NewVisitorForm  isNri={true}/>}
          />

          <Route
            path="/uploadPhoto"
            element={<UploadPhoto />}
          />
          {/* <Route
            jas-2026
            path="/jgc-visitor-registration"
            element={<NewVisitorForm />}
          /> */}
          {/*  */}

          {/* <Route
            path="/exhibitor-vip-registration"
            element={<ExhibitorVip />}
          /> */}
          {/* <Route
            path="/exhibitor-owner-registration"
            element={<ExhibitorOwner />}
          /> */}
          <Route
            path="/vendor-owner-registration/:barcode"
            element={<VendorOwner />}
          />
          <Route
            path="/vendor-staff-registration/:barcode"
            element={<VendorStaff />}
          />
          {/* <Route path="/vip-guest-registration" element={<ExhibitorVip />} /> */}
          <Route path="/hosted-buyer-registration" element={<BuyerRegistration formStatus={true} />} />
          <Route path="/original-buyer-registration" element={<BuyerRegistration formStatus={false} />} />
          <Route path="/404" element={<Wrong404 />} />
          <Route path="/*" element={<MainRoute />} />

          {/* Sub-Admin Routes */}
          <Route path="/subadmin/dashboard" element={<SubAdminRoute><SubAdminDashboard /></SubAdminRoute>} />
          <Route path="/subadmin/areas" element={<SubAdminRoute><SubAdminAreas /></SubAdminRoute>} />
          <Route path="/subadmin/buyers/*" element={<SubAdminRoute><SubAdminBuyers /></SubAdminRoute>} />
          <Route path="/subadmin/visitors" element={<SubAdminRoute><SubAdminVisitors /></SubAdminRoute>} />
          <Route path="/subadmin/exhibitors" element={<SubAdminRoute><SubAdminExhibitors /></SubAdminRoute>} />
          <Route path="/subadmin/change-password" element={<SubAdminRoute><SubAdminChangePassword /></SubAdminRoute>} />
        </Routes>

      </Suspense>
    </>
  );
}

export default App;
